import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme)=> ({
    label: {
        width: "30%",
        fontSize: "14px",
        lineHeight: "36px"
    },
    value: {
        width: '70%'
    },
    row: {
        marginBottom: theme.spacing(1.5)
    },
    divider: {
        margin: theme.spacing(1, 0)
    }
}))